/* 🤖 this file was generated by svg-to-ts */
export const mgcIconSpaceRegular: {
  name: 'space-regular';
  data: string;
} = {
  name: 'space-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.673 9.063c-.244.075-.523.351-.609.603-.055.162-.064.43-.062 1.891.002 1.476.012 1.738.071 1.966.18.689.787 1.272 1.476 1.418.407.086 16.495.086 16.902 0 .371-.078.641-.232.95-.54.308-.309.462-.579.54-.95.086-.407.085-3.47-.002-3.761C21.827 9.312 21.402 9 21 9c-.236 0-.514.121-.694.3-.302.302-.306.33-.306 2.127V13H4v-1.553c0-1.797-.007-1.848-.303-2.144-.279-.279-.63-.361-1.024-.24"/></svg>`
};
